export { default as FooterContainer } from './footer-container';
